import React from 'react';
import PropTypes from 'prop-types';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import {
  Box,
  Button,
  Card,
  Text,
} from '../../../components';
import { DROPDOWN_FIELD, TEXT_FIELD } from '../fields/FormField';

const propTypes = {
  fieldTypes: PropTypes.arrayOf(PropTypes.string),
  previewMode: PropTypes.bool,
  togglePreviewMode: PropTypes.func,
};

const defaultProps = {
  fieldTypes: undefined,
  previewMode: false,
  togglePreviewMode: undefined,
};

function EditFormPanel({ fieldTypes, previewMode, togglePreviewMode }) {
  // TODO this should match the name displayed on the individual fields,
  // so we should drive it from the same source data
  const fieldTypeDisplayName = {
    [DROPDOWN_FIELD]: 'Dropdown Selection',
    [TEXT_FIELD]: 'Text Input',
  };

  const fieldOptions = fieldTypes.map((fieldType, index) => (
    <Draggable
      key={fieldType}
      draggableId={`EditFormPanelFieldOption-${fieldType}`}
      index={index}
    >
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Card>
            <Card.Block>
              <Text as="h4">{fieldTypeDisplayName[fieldType]}</Text>
            </Card.Block>
          </Card>
          <Box height="0.25em" />
        </div>
      )}
    </Draggable>
  ));

  return (
    <div>
      <Droppable droppableId="EditFormPanel">
        {/* We cannot use a React component directly, since their refs behaves differently. */}
        {provided => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {fieldOptions}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <Box height="2em" />
      <Button primary fullWidth onClick={togglePreviewMode}>
        {previewMode ? 'Return to Edit Mode' : 'Switch to Preview'}
      </Button>
    </div>
  );
}
EditFormPanel.propTypes = propTypes;
EditFormPanel.defaultProps = defaultProps;
export default EditFormPanel;
